import { apiClient } from './apiClient';

const loginAdminUser = async (data) => {
  return await apiClient.post_form('/dashboard/auth/login', data);
};

const logoutAdminUser = async (data) => {
  return await apiClient.get('/dashboard/logout', data);
};

const getAdminSession = async (data) => {
  return await apiClient.post('/dashboard/check', data);
};

export const adminAuthApi = {
  loginAdminUser,
  logoutAdminUser,
  getAdminSession,
};
